const routes = [
  {
    path: '',
    meta: {
      public: true,
    },
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: 'error-404',
        name: 'error-404',
        component: () => import('@/views/error/Error404.vue'),
      },
      {
        path: 'error-500',
        name: 'error-500',
        component: () => import('@/views/error/Error500.vue'),
      },
      {
        path: 'error-403',
        name: 'error-403',
        component: () => import('@/views/error/Error403.vue'),
      },
      {
        path: 'settings-error',
        name: 'settings-error',
        component: () => import('@/views/error/SettingsError.vue'),
      },
    ],
  },
];

export default routes;
